import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import {loadSession, setLoading} from "@app/common/store/action";
import * as Yup from "yup";
import style from './resetpassword.module.css'
import get from "lodash/get";
import {Button, Divider, Grid, TextField, Typography} from "@material-ui/core";
import {  withRouter } from "react-router-dom";

import {

    CHG_PWD_SUC, CHG_PWD_SUC_TITLE,

} from "@app/common/constants/constants";
import ErrorTextContainer from "../../../components/errortextcontainer/errortextcontainer";
import {
    FORGOT_CONFIRM_OTP_PASSWORD_ROUTE, LOGIN_ROUTE,

} from "../../../constants/routeconstants";

import CustomButton from "../../../components/custombutton/custombutton";
import {resetPasswordService} from "@app/common/services/resetpasswordservice";
import {CANCEL, EMAIL_RECOVERY, USER_NAME_REQUIRED} from "../../../constants/appconstants";

class ResetPasswordForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showError: 0,
            message:"",
            openDialog:false,
            dialogText:"",
            dialogTitle:"",
            errorText:"",
        };
    }

    submitAction = (fields) => {
        const {actions} =  this.props;
        actions.setLoading(true);
        this.resetPasswordSubmit(fields)
    };

    resetPasswordSubmit = async(fields)=>{
        const { actions } = this.props;

        try{
            await resetPasswordService(fields);
            actions.setLoading(false);
            this.setState({dialogText:CHG_PWD_SUC,openDialog:true,dialogTitle:CHG_PWD_SUC_TITLE})
            console.log("fields",fields)
            this.props.history.push({pathname:FORGOT_CONFIRM_OTP_PASSWORD_ROUTE,state:{userName:fields.userName}})
        }catch(e){
            // this.setState({dialogText:e,openDialog:true,dialogTitle:"Session Expired"})
            actions.setLoading(false);
            this.setState({errorText:e});
        }
    }

    handleDialogClose = ()=>{
        const prevPath = get(this, "props.location.state.prevPath");
        this.props.history.push(prevPath)
    }
    render() {
        const userName = get(this, "props.location.state.userName");
        return (
            <Formik
                initialValues={{
                    userName: userName,
                }}
                validationSchema={Yup.object().shape({
                    userName: Yup.string().required(USER_NAME_REQUIRED)
                })}
                onSubmit={(fields) => {
                     this.submitAction(fields);
                }}
                render={({errors, touched, values,handleChange}) => (
                    <Form style={{minWidth: "330px"}}>
                        <Grid container direction={"column"}>
                            <Grid item>
                                <div className={style.reset_password_form_error}>
                                    <ErrorTextContainer text={this.state.errorText}/>
                                </div>
                            </Grid>
                            <Grid item className={style.reset_password_form_text_field_container}>
                                <TextField
                                    id={"outlined-basic"}
                                    name="userName"
                                    type="text"
                                    variant={"outlined"}
                                    onChange={handleChange}
                                    label={"Username"}
                                    className={style.reset_password_form_text_field}
                                    error={errors.userName && touched.userName}
                                    helperText={touched.userName && errors.userName}
                                />

                            </Grid>
                            <Grid item>
                                <Grid container justify={"center"} className={style.reset_password_form_button_container}>
                                    <Grid item lg={12}>
                                       <CustomButton title= {EMAIL_RECOVERY}/>
                                    </Grid>
                                    <Grid item lg={12} className={style.reset_password_form_button_spacing}>
                                        <CustomButton title= {CANCEL} onSubmitHandler={()=>{this.props.history.push(LOGIN_ROUTE)}}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    session:state.session,

});


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ setLoading,loadSession }, dispatch),
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(ResetPasswordForm);
